import React from 'react';

import {SettingType} from '../../../../services/analytics/workspaceSettingsEvents';
import {SettingToggleRow} from '../components/SettingToggleRow';
import {LinePlotSettings} from '../types';

export const LinePlotCoordinateZooming = ({
  coordinateZooming,
  trackSetting,
  updateSetting,
}: {
  coordinateZooming: boolean;
  trackSetting: (setting: SettingType, value: string | undefined) => void;
  updateSetting: (settings: Partial<LinePlotSettings>) => void;
}) => {
  return (
    <SettingToggleRow
      description="Synchronize zooming across line plots with a matching x-axis key"
      displayValue={coordinateZooming}
      label="Zooming"
      onCheckedChange={(newValue: boolean) => {
        updateSetting({
          coordinateZooming: newValue,
        });
        trackSetting('coordinateZooming', newValue.toString());
      }}
      value={coordinateZooming}
    />
  );
};
